import React, { useEffect, useState } from "react";
import Footer from "../../../Components/Footer/footer";
import SimpleButton from "../../../Components/layouts/simple_button";
import { useParams } from "react-router-dom";
import LoadingPage from "../../../Components/layouts/loading";
import { Toast } from "../../../CustomComponent/toast";
import performRequest from "../../../api/request";
import { FcPuzzle } from "react-icons/fc";
import { CustomErrorResponse } from "../../../CustomComponent/custom_error_response";

const ViewQuotationMatrix = () => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState();
  let { id } = useParams();
  useEffect(() => {
    setLoading(true);
    performRequest("GET", `/quotationMatrix/getQuotationMatrixById/${id}`)
      .then((res) => {
        if (res.status === 200) {
          setData(res.data);
        } else {
          Toast("error", "Error while getting Expense!");
        }
        setLoading(false);
      })

      .catch((err) => {
        CustomErrorResponse(err);
      })
      .finally(() => setLoading(false));
  }, [id]);

  if (loading) {
    return <LoadingPage />;
  }

  return (
    <div className="page">
      <div className="page-wrapper">
        <div className="container-xxl">
          <div className="page-header d-print-none">
            <div className="row align-items-center">
              <div className="col-md-8">
                <h2 className="page-title mb-1">
                  <FcPuzzle className="fs-2  me-1" /> Quotation Matrix
                </h2>
                <h4 className="text-muted">
                  {/* <StepRoutes /> */} Base values that affect quotation
                  pricing.
                </h4>
              </div>
              <div className="col-md-4"></div>
            </div>
          </div>

          <div className="row">
            <div className="col-md-3 col-sm-12 py-2">
              <div className="card p-3">
                <p>
                  The pricing you enter will affect quotation pricing in
                  realtime.
                </p>
                <p>
                  Take backup of pricing before making any changes to quotation.
                </p>
                <p>
                  Only Super admins and admins can make changes to quotation
                  matrix.
                </p>
              </div>
            </div>
            <div className="col-md-9 col-sm-12 py-2">
              <div className="card">
                <table class="table table-vcenter card-table table-striped">
                  <thead>
                    <tr>
                      <th className="w-33">Specs</th>
                      <th>Details</th>
                    </tr>
                  </thead>
                  <tbody>
                    {data && (
                      <tr>
                        <td class="text-secondary">Type of the System</td>
                        <td>{(data?.type || "N/A").toUpperCase()}</td>
                      </tr>
                    )}
                    {data && (
                      <tr>
                        <td class="text-secondary">Factor</td>
                        <td>{(data?.factor || "N/A").toUpperCase()}</td>
                      </tr>
                    )}
                    {data && (
                      <tr>
                        <td class="text-secondary">Unit</td>
                        <td>{(data?.unit || "N/A").toUpperCase()}</td>
                      </tr>
                    )}
                    {data && (
                      <tr>
                        <td class="text-secondary">Description</td>
                        <td>{(data?.description || "N/A").toUpperCase()}</td>
                      </tr>
                    )}
                    {data && (
                      <tr>
                        <td class="text-secondary">Base price 0-100</td>
                        <td>{data?.basePrice0To100}</td>
                      </tr>
                    )}
                    {data && (
                      <tr>
                        <td class="text-secondary">Base price 101-200</td>
                        <td>{data?.basePrice101To200}</td>
                      </tr>
                    )}
                    {data && (
                      <tr>
                        <td class="text-secondary">Base price 201-400</td>
                        <td>{data?.basePrice201To400}</td>
                      </tr>
                    )}
                    {data && (
                      <tr>
                        <td class="text-secondary">Base price 401-500</td>
                        <td>{data?.basePrice401To500}</td>
                      </tr>
                    )}
                    {data && (
                      <tr>
                        <td class="text-secondary">Base price 501-1000</td>
                        <td>{data?.basePrice501To1000}</td>
                      </tr>
                    )}
                    {data && (
                      <tr>
                        <td class="text-secondary">Base price 1001-1500</td>
                        <td>{data?.basePrice1001To1500}</td>
                      </tr>
                    )}
                    {data && (
                      <tr>
                        <td class="text-secondary">Base price 1501-2000</td>
                        <td>{data?.basePrice1501To2000}</td>
                      </tr>
                    )}
                    {data && (
                      <tr>
                        <td class="text-secondary">Base price 2001-2500</td>
                        <td>{data?.basePrice2001To2500}</td>
                      </tr>
                    )}
                    {data && (
                      <tr>
                        <td class="text-secondary">Base price 2501-3000</td>
                        <td>{data?.basePrice2501To3000}</td>
                      </tr>
                    )}
                    {data && (
                      <tr>
                        <td class="text-secondary">Base price 3001-3500</td>
                        <td>{data?.basePrice3001To3500}</td>
                      </tr>
                    )}
                    {data && (
                      <tr>
                        <td class="text-secondary">Base price 3501-4000</td>
                        <td>{data?.basePrice3501To4000}</td>
                      </tr>
                    )}
                    {data && (
                      <tr>
                        <td class="text-secondary">Base price 4001-4500</td>
                        <td>{data?.basePrice4001To4500}</td>
                      </tr>
                    )}
                    {data && (
                      <tr>
                        <td class="text-secondary">Base price 4501-5000</td>
                        <td>{data?.basePrice4501To5000}</td>
                      </tr>
                    )}
                    {data && (
                      <tr>
                        <td class="text-secondary">Base price 5001-5500</td>
                        <td>{data?.basePrice5001To5500}</td>
                      </tr>
                    )}
                    {data && (
                      <tr>
                        <td class="text-secondary">Base price 5501-6000</td>
                        <td>{data?.basePrice5501To6000}</td>
                      </tr>
                    )}
                    {data && (
                      <tr>
                        <td class="text-secondary">Base price 6001-6500</td>
                        <td>{data?.basePrice6001To6500}</td>
                      </tr>
                    )}
                    {data && (
                      <tr>
                        <td class="text-secondary">Base price 6501-7000</td>
                        <td>{data?.basePrice6501To7000}</td>
                      </tr>
                    )}
                    {data && (
                      <tr>
                        <td class="text-secondary">Base price 7001-7500</td>
                        <td>{data?.basePrice7001To7500}</td>
                      </tr>
                    )}
                    {data && (
                      <tr>
                        <td class="text-secondary">Base price 7501-8000</td>
                        <td>{data?.basePrice7501To8000}</td>
                      </tr>
                    )}
                    {data && (
                      <tr>
                        <td class="text-secondary">Base price 8000+</td>
                        <td>{data?.basePriceGreater8000}</td>
                      </tr>
                    )}
                    {data && (
                      <tr>
                        <td class="text-secondary">Weedmat</td>
                        <td>{data?.sqMtrWeed}</td>
                      </tr>
                    )}
                    {data && (
                      <tr>
                        <td class="text-secondary">Markup 0-100</td>
                        <td>{data?.markupPercent0To100}</td>
                      </tr>
                    )}
                    {data && (
                      <tr>
                        <td class="text-secondary">Markup 101-200</td>
                        <td>{data?.markupPercent101To200}</td>
                      </tr>
                    )}
                    {data && (
                      <tr>
                        <td class="text-secondary">Markup 201-400</td>
                        <td>{data?.markupPercent201To400}</td>
                      </tr>
                    )}
                    {data && (
                      <tr>
                        <td class="text-secondary">Markup 401T-500</td>
                        <td>{data?.markupPercent401To500}</td>
                      </tr>
                    )}
                    {data && (
                      <tr>
                        <td class="text-secondary">Markup 501-1000</td>
                        <td>{data?.markupPercent501To1000}</td>
                      </tr>
                    )}
                    {data && (
                      <tr>
                        <td class="text-secondary">Markup 1001-1500</td>
                        <td>{data?.markupPercent1001To1500}</td>
                      </tr>
                    )}
                    {data && (
                      <tr>
                        <td class="text-secondary">Markup 1501-2000</td>
                        <td>{data?.markupPercent1501To2000}</td>
                      </tr>
                    )}
                    {data && (
                      <tr>
                        <td class="text-secondary">Markup 2001-2500</td>
                        <td>{data?.markupPercent2001To2500}</td>
                      </tr>
                    )}
                    {data && (
                      <tr>
                        <td class="text-secondary">Markup 2501-3000</td>
                        <td>{data?.markupPercent2501To3000}</td>
                      </tr>
                    )}
                    {data && (
                      <tr>
                        <td class="text-secondary">Markup 3001-3500</td>
                        <td>{data?.markupPercent3001To3500}</td>
                      </tr>
                    )}
                    {data && (
                      <tr>
                        <td class="text-secondary">Markup 3501-4000</td>
                        <td>{data?.markupPercent3501To4000}</td>
                      </tr>
                    )}
                    {data && (
                      <tr>
                        <td class="text-secondary">Markup 4001-4500</td>
                        <td>{data?.markupPercent4001To4500}</td>
                      </tr>
                    )}
                    {data && (
                      <tr>
                        <td class="text-secondary">Markup 4501-5000</td>
                        <td>{data?.markupPercent4501To5000}</td>
                      </tr>
                    )}
                    {data && (
                      <tr>
                        <td class="text-secondary">Markup 5001-5500</td>
                        <td>{data?.markupPercent5001To5500}</td>
                      </tr>
                    )}
                    {data && (
                      <tr>
                        <td class="text-secondary">Markup 5501-6000</td>
                        <td>{data?.markupPercent5501To6000}</td>
                      </tr>
                    )}
                    {data && (
                      <tr>
                        <td class="text-secondary">Markup 6001-6500</td>
                        <td>{data?.markupPercent6001To6500}</td>
                      </tr>
                    )}
                    {data && (
                      <tr>
                        <td class="text-secondary">Markup 6501-7000</td>
                        <td>{data?.markupPercent6501To7000}</td>
                      </tr>
                    )}
                    {data && (
                      <tr>
                        <td class="text-secondary">Markup 7001-7500</td>
                        <td>{data?.markupPercent7001To7500}</td>
                      </tr>
                    )}
                    {data && (
                      <tr>
                        <td class="text-secondary">Markup 7501-8000</td>
                        <td>{data?.markupPercent7501To8000}</td>
                      </tr>
                    )}
                    {data && (
                      <tr>
                        <td class="text-secondary">Markup 8000+</td>
                        <td>{data?.markupPercentGreater8000}</td>
                      </tr>
                    )}
                  </tbody>
                </table>
                <div className="card-footer">
                  <div className="btn-list justify-content-end">
                    <SimpleButton
                      buttonText="Edit Quotation Matrix"
                      href={`/standard-quotation/edit/${id}`}
                    />
                    <SimpleButton buttonText="Cancel" type="secondary" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <Footer />
      </div>
    </div>
  );
};

export default ViewQuotationMatrix;
